<template>
  <el-form :model="form" label-width="120px" @submit.prevent="submitForm">
    <el-form-item label="Comment">
      <el-input type="textarea" v-model="form.content" :rows="4" required></el-input>
    </el-form-item>

    <el-form-item label="Review Score" v-if="isReview">
      <el-rate v-model="form.review_score"></el-rate>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" native-type="submit">Submit</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    postId: {
      type: Number,
      required: true
    },
    submitUrl: {
      type: String,
      required: true
    },
    userRole: {
      type: String,
      required: true
    },
    isReview: {
      type: Boolean,
      default: false
    },
    existingReview: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        content: this.existingReview?.content || '',
        is_review: this.isReview,
        review_score: this.existingReview?.review_score || 0,
      },
    }
  },
  methods: {
    async submitForm() {
      try {
        const response = await axios.post(this.submitUrl, this.form)
        console.log('Comment submitted successfully:', response.data)
        this.$emit('comment-submitted', response.data)
        this.resetForm()
        window.location.href = `${window.location.pathname}#comment-${response.data.id}`
        window.location.reload()
      } catch (error) {
        console.error('Error submitting comment:', error)
        this.$emit('comment-error', error)
        this.$message.error('An error occurred while submitting the comment. Please try again.')
      }
    },
    resetForm() {
      this.form = {
        content: '',
        is_review: false,
        review_score: 0,
      }
    },
    editComment(commentId) {
      // Implement edit functionality
    },
    deleteComment(commentId) {
      // Implement delete functionality
    }
  },
}
</script>
